import { observable } from 'mobx';

class DialogStore {
  @observable open = false;
}

export default DialogStore;
